// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-item {
    padding: 1rem 1rem !important;
}

.menu-item {
    min-width: 140px;
    cursor: pointer;
}

.dropdown-item:hover {
    background-color: #EFC427;
}


.menu-item:focus {
    background-color: #EFC427;
}

.menu-item:hover {
    background-color: #EFC427;
}

.logo-none {
    display: none !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhlYWRlci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksNkJBQTZCO0FBQ2pDOztBQUVBO0lBQ0ksZ0JBQWdCO0lBQ2hCLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSx5QkFBeUI7QUFDN0I7OztBQUdBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0ksd0JBQXdCO0FBQzVCIiwiZmlsZSI6ImhlYWRlci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRyb3Bkb3duLWl0ZW0ge1xuICAgIHBhZGRpbmc6IDFyZW0gMXJlbSAhaW1wb3J0YW50O1xufVxuXG4ubWVudS1pdGVtIHtcbiAgICBtaW4td2lkdGg6IDE0MHB4O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLmRyb3Bkb3duLWl0ZW06aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNFRkM0Mjc7XG59XG5cblxuLm1lbnUtaXRlbTpmb2N1cyB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI0VGQzQyNztcbn1cblxuLm1lbnUtaXRlbTpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI0VGQzQyNztcbn1cblxuLmxvZ28tbm9uZSB7XG4gICAgZGlzcGxheTogbm9uZSAhaW1wb3J0YW50O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/sharing/header/header.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,w3BAAw3B","sourcesContent":[".dropdown-item {\n    padding: 1rem 1rem !important;\n}\n\n.menu-item {\n    min-width: 140px;\n    cursor: pointer;\n}\n\n.dropdown-item:hover {\n    background-color: #EFC427;\n}\n\n\n.menu-item:focus {\n    background-color: #EFC427;\n}\n\n.menu-item:hover {\n    background-color: #EFC427;\n}\n\n.logo-none {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
